/**
 * Creates an artificial delay for better UX by showing loading states for a minimum duration
 * @param ms - Delay duration in milliseconds (default: 500ms)
 * @returns Promise that resolves after the specified delay
 */
export const artificialDelay = (ms: number = 500): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(undefined), ms);
  });
};
